import React, { createContext, useContext, useState, useEffect } from "react";

interface SessionData {
  sessionId: string;
  oneLoginSub?: string;
  // any additional session data you want to include
}

interface SessionContextValue {
  session: SessionData | null;
  setSession: React.Dispatch<React.SetStateAction<SessionData | null>>;
}

interface SessionProviderProps {
  children: React.ReactNode;
}

const SessionContext = createContext<SessionContextValue | undefined>(undefined);

export const SessionProvider: React.FC<SessionProviderProps> = ({ children }) => {
  const [session, setSession] = useState<SessionData | null>(null);

  useEffect(() => {
    // Get oneLoginSub from localStorage
    const oneLoginSub = localStorage.getItem("oneLoginSub") || "";
    // Append oneLoginSub as a query parameter if it exists
    const url = oneLoginSub
      ? `https://api.psanalytics.co.uk/ncjp/session?service=session&action=index&oneLoginSub=${encodeURIComponent(oneLoginSub)}`
      : "https://api.psanalytics.co.uk/ncjp/session?service=session&action=index";

    fetch(url, {
      credentials: "include", // so cookies are sent
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setSession({
            sessionId: data.session.session_id,
            oneLoginSub: oneLoginSub || undefined,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching session data:", err);
      });
  }, []);

  return (
    <SessionContext.Provider value={{ session, setSession }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = (): SessionContextValue => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return context;
};
